module.exports = __webpack_public_path__ + "static/media/archway.0fe0baba.svg";